import { render, staticRenderFns } from "./DialogArticleNew.vue?vue&type=template&id=72bdd2f0"
import script from "./DialogArticleNew.vue?vue&type=script&lang=js"
export * from "./DialogArticleNew.vue?vue&type=script&lang=js"
import style0 from "./DialogArticleNew.vue?vue&type=style&index=0&id=72bdd2f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports